interface SplitToggleProps {
  enabled: boolean;
  maxPlayers: number;
  onToggle: () => void;
  onMaxPlayersChange: (maxPlayers: number) => void;
}

export function SplitToggle({ enabled, maxPlayers, onToggle, onMaxPlayersChange }: SplitToggleProps) {
  return (
    <div className="flex items-center justify-between rounded-xl border border-border/70 bg-background px-4 py-3">
      <label className="flex items-center gap-2 text-sm text-ink">
        <input type="checkbox" checked={enabled} onChange={onToggle} className="accent-primary" />
        Dividir com até {maxPlayers} jogadores no checkout
      </label>

      {enabled && (
        <div className="flex items-center gap-2">
          <button
            type="button"
            onClick={() => onMaxPlayersChange(Math.max(2, maxPlayers - 1))}
            className="h-7 w-7 rounded-full border border-border text-ink hover:border-primary"
          >
            −
          </button>
          <button
            type="button"
            onClick={() => onMaxPlayersChange(Math.min(4, maxPlayers + 1))}
            className="h-7 w-7 rounded-full border border-border text-ink hover:border-primary"
          >
            +
          </button>
        </div>
      )}
    </div>
  );
}
